module.exports = __webpack_public_path__ + "img/film.f363ce66.png";